import script from "./aside.vue?vue&type=script&setup=true&lang=js"
export * from "./aside.vue?vue&type=script&setup=true&lang=js"

import "./aside.vue?vue&type=style&index=0&id=60bfe2c4&lang=css"

const __exports__ = script;

export default __exports__